class ExperienceIndexDataClient {
  constructor(apiBase) {
    this.apiBase = apiBase;
  }
  async fetch(distributionId, options) {
    const {
      static: isStatic = true
    } = options ?? {};
    const url = new URL(`${this.apiBase}/experience/data/${distributionId}`);
    if (isStatic)
      url.searchParams.set("static", "true");
    return await fetch(url, { method: "GET" }).then(async (res) => await res.json());
  }
}
export {
  ExperienceIndexDataClient
};
